import React from 'react'
import BarLoader from "react-spinners/BarLoader";


import styles from "./Loader.module.css";

export default function Loader(props) {
    return (
        <>
            <div className={`d-flex align-items-center justify-content-center ${styles.loader_container}`}>
                <div className="row d-flex justify-content-center">
                    {/* <div className="col-12 mb-4 pt-1">
                        <div className='p-2 text-center mx-auto w-25'>
                            <div>
                                <img src="" alt="" className={`img-fluid mx-auto d-block fade-in`} />
                            </div>
                        </div>
                    </div> */}
                    <div>
                        <p className='fw-bold text-center text-42526a'>Loading...</p>
                    </div>
                    <BarLoader className="d-inline" color="#42526a" loading={props.loading} speedMultiplier={1} margin={1} height={5} width={150} />
                </div>
            </div>
        </>
    )
}
